import Vue from 'vue'
import VueX from 'vuex'
import MenuItem from '@/lib/transfer-objects/MenuItem'
import HeaderStore from './header-store'
import user from './modules/user'
import counter from './modules/counter'

Vue.use(VueX)

const commits = {
  UPDATE_USER: 'UPDATE_USER',
  UPDATE_HEADER: 'UPDATE_HEADER',
  UPDATE_PUSHED_APPS: 'UPDATE_PUSHED_APPS',
  UPDATE_HEADER_NAME: 'UPDATE_HEADER_NAME',
  SET_LOADING: 'SET_LOADING'
}

let apps = [
  new MenuItem({label: 'Accueil', href: '/', icon: 'home'}),
  new MenuItem({label: 'Utilisateurs', href: '/user/list', key: 'UserList'}),
  new MenuItem({label: 'Parcs', href: '/site/list?currentPage=1', key: 'SiteList'}),
  new MenuItem({label: 'Messages', href: '/messages', key: 'MessagesIndex'}),
  new MenuItem({label: 'Liens Utiles', href: '/link/list', key: 'LinkList'}),
  new MenuItem({label: 'Notifications', href: '/notification/list'}),
  new MenuItem({label: 'Vidéos', href: '/video/list', key: 'VideoList'}),
  new MenuItem({label: 'Monitoring', href: '/monitoring', key: 'MonitoringIndex'})
]

let userProfileMenu = [
]

export default new VueX.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    header: {},
    loading: false,
    userProfileMenu: userProfileMenu,
    apps: {
      pushed: apps,
      all: apps
    }
  },
  mutations: {
    [commits.UPDATE_HEADER] (state, header) {
      Vue.$log.debug('UPDATE_HEADER', header)
      state.header = header
    },
    [commits.UPDATE_HEADER_NAME] (state, headerName) {
      Vue.$log.debug('UPDATE_HEADER_NAME', headerName)

      if (state.header) {
        state.header.title = headerName
      }
    },

    [commits.UPDATE_USER] (state, user) {
      Vue.$log.debug('UPDATE_USER', user)
      state.user = user
    },
    [commits.SET_LOADING] (state, loading) {
      state.loading = loading
    },
    [commits.UPDATE_PUSHED_APPS] (state) {
      var that = this
      state.apps.pushed.forEach(element => {
        if (element.key === 'UserList') {
          element.badge = that.getters.counters.newUsers
        } else if (element.key === 'UnreadMessageBySite') {
          element.badge = that.getters.counters.newMessages
        }
      })
    }
  },
  getters: {
    userProfileMenu (state) {
      return state.userProfileMenu
    },
    header (state) {
      return state.header
    },
    pushedApps (state) {
      return state.apps.pushed
    },
    apps (state) {
      return state.apps.rest
    }
  },
  actions: {
    setBadges ({ commit }) {
      commit(commits.UPDATE_PUSHED_APPS)
    }
  },
  modules: {
    header: HeaderStore,
    user,
    counter
  }
})
export {commits}



// WEBPACK FOOTER //
// ./src/store/main.js